import { activityMatchesBoardHashtag, getActivityHashtagLoweredNames } from './activityHashtag';

export function getActivityHostname(activity) {
  const url = activity?.content?.[0]?.urls?.[0];
  if (!url) return null;
  const hostname = url.hostname || url.host || '';
  if (!hostname) return null;
  return hostname.replace(/^www\./i, '').toLowerCase();
}

export function getActivityCommentText(activity) {
  const content = activity?.content?.[0];
  if (!content?.comments?.length) return '';
  const comment = content.comments[0];
  return String(comment?.text || comment?.body || '').trim();
}

export function filterActivitiesByBoard(activities, boardName) {
  if (!boardName || !Array.isArray(activities)) return activities;
  return activities.filter(a => activityMatchesBoardHashtag(a, boardName));
}

export function filterActivitiesBySearch(activities, query) {
  if (!query || !Array.isArray(activities)) return activities;
  const q = String(query).trim().toLowerCase();
  if (!q) return activities;
  return activities.filter(activity => {
    const comment = getActivityCommentText(activity).toLowerCase();
    const hostname = getActivityHostname(activity) || '';
    const href = activity?.content?.[0]?.urls?.[0]?.href || '';
    const tags = getActivityHashtagLoweredNames(activity).join(' ');
    return (
      comment.includes(q) ||
      hostname.includes(q) ||
      href.toLowerCase().includes(q) ||
      tags.includes(q)
    );
  });
}

export function applyLibraryFilters(activities, { section, boardName, searchQuery }) {
  if (!Array.isArray(activities)) return [];

  let result = activities;

  if (boardName && section === 'board') {
    result = filterActivitiesByBoard(result, boardName);
  }

  if (searchQuery) {
    result = filterActivitiesBySearch(result, searchQuery);
  }

  return result;
}
